import { Box, SxProps } from "@mui/material";

interface Props {
    customStyles?: SxProps;
    children: React.ReactNode;
}

export const CenterBox: React.FC<Props> = ({customStyles, children}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center', // Alinea el texto
                ...customStyles,
            }}
        >
            {children}
        </Box>
    )
}